'use client';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useWorkflowStore } from '../../../stores/workflowStore';
import { Info } from '@phosphor-icons/react';

interface AppendConfigProps {
  nodeId: string;
  config: { ignoreSchema?: boolean };
}

export function AppendConfig({ nodeId, config }: AppendConfigProps) {
  const { t } = useTranslation();
  const { updateNodeConfig } = useWorkflowStore();
  const [ignoreSchema, setIgnoreSchema] = useState(config.ignoreSchema || false);

  // 当 config 变化时（如 AI 生成工作流后），同步更新内部状态
  useEffect(() => {
    if (typeof config.ignoreSchema === 'boolean') {
      setIgnoreSchema(config.ignoreSchema);
    }
  }, [config.ignoreSchema]);

  const handleChange = (checked: boolean) => {
    setIgnoreSchema(checked);
    updateNodeConfig(nodeId, { type: 'append', params: { ignoreSchema: checked } });
  };

  return (
    <div className="space-y-4">
      <label className="flex items-start gap-3 cursor-pointer p-3 rounded-xl border border-zinc-200 hover:border-zinc-300 transition-colors">
        <input type="checkbox" checked={ignoreSchema}
          onChange={(e) => handleChange(e.target.checked)}
          className="mt-0.5 w-4 h-4 text-emerald-600 rounded border-zinc-300 focus:ring-emerald-500"
        />
        <div>
          <div className="text-sm font-medium text-zinc-800">
            {t('nodes.config.append.ignoreSchema')}
          </div>
          <div className="text-xs text-zinc-500 mt-0.5">
            {t('nodes.config.append.ignoreSchemaDesc')}
          </div>
        </div>
      </label>

      <div className="flex items-start gap-2 p-3 bg-blue-50 rounded-xl border border-blue-100">
        <Info className="w-4 h-4 text-blue-500 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-blue-700">
          {t('nodes.config.append.description')}
        </p>
      </div>
    </div>
  );
}
